import React from 'react';
import PropTypes from 'prop-types';

class CustomFieldValueRow extends React.Component {
  state = {
    editMode: false,
    deleteMode: false,
    value: this.props.value
  }

  toggleEditMode = () => {
    this.setState((prevState) => ({
      editMode: !prevState.editMode,
      deleteMode: !prevState.editMode ? false : prevState.deleteMode
    }));
  }

  toggleDeleteMode = () => {
    this.setState((prevState) => ({
      deleteMode: !prevState.deleteMode,
      editMode: !prevState.deleteMode ? false : prevState.editMode
    }));
  }

  updateValue = (event) => {
    this.setState({ value: event.target.value });
  }

  renameValue = () => {
    const { updateValues, value } = this.props;
    if (this.state.value && this.state.value !== value.value) {
      updateValues(value, this.state.value);
      this.setState({ editMode: false });
    } else {
      Notify.create({
        title: t('Please enter a value.'),
        type: 'error',
      });
    }
  }

  deleteValue = () => {
    const { updateValues, value } = this.props;
    updateValues(value, null);
    this.setState({ deleteMode: false });
  }

  showKey() {
    const { count } = this.props;
    return (
      <React.Fragment>
        <div className="show-custom-fields-values-mode">
          <div className="custom-fields-values-information">
            <div className="custom-field-key quarter-width">
              <p>{this.props.customFieldKey.name}</p>
            </div>
            { this.renderValue() }
            <div className="twenty-width">
              <p>{t((count > 1) ? `${count} Assets` : "1 Asset")}</p>
            </div>
          </div>
          <div className="button-container">
            <button
              className="button tertiary sm edit-custom-fields"
              onClick={this.toggleEditMode}
              type="button"
            >
              Rename
            </button>
            <button
              className="delete-custom-fields"
              onClick={this.toggleDeleteMode}
              onKeyUp={this.toggleDeleteMode}
              type="button"
            >
              <span className="bff-trash" />
            </button>
          </div>
        </div>
      </React.Fragment>
    );
  }

  renderValue() {
    const { value, customFieldKey } = this.props;
    return (
      <div className="twenty-width">
        <a href={`/${BF.fx.brandfolder().slug}?q=custom_fields.${customFieldKey.name}.moderate:("${escape(value)}")`}>
          <span className="custom-fields-value">
            {value}
          </span>
        </a>
      </div>
    );
  }

  renderEdit() {
    const { value, count } = this.props;
    return (
      <div className="edit-custom-field-values-mode">
        <input
          id={`${value}-input`}
          type="text"
          defaultValue={value}
          onChange={this.updateValue}
        />
        <div className="edit-buttons">
          <button
            className="button tertiary md cancel"
            type="button"
            onClick={this.toggleEditMode}
          >
          Cancel
          </button>
          <button
            className="button primary md"
            type="button"
            onClick={this.renameValue}
          >
            {t(`Rename ${count > 0 ? count : ""} Value${(count > 1) ? "s" : ""}`)}
          </button>
        </div>
      </div>
    );
  }

  renderDelete() {
    const { count } = this.props;
    return (
      <div className="delete-custom-field-values-mode">
        {this.renderValue()}
        <div className="delete-buttons">
          <button
            className="button tertiary md cancel"
            type="button"
            onClick={this.toggleDeleteMode}
          >
            {t("Cancel")}
          </button>
          <button
            className="button warning md"
            type="button"
            onClick={this.deleteValue}
          >
            {t(`Delete ${count} Value${(count > 1) ? "s" : ""}`)}
          </button>
        </div>
      </div>
    );
  }

  renderRow() {
    const { editMode, deleteMode } = this.state;
    if (editMode) { return this.renderEdit(); }
    if (deleteMode) { return this.renderDelete(); }
    return this.showKey();
  }

  render() {
    return this.renderRow();
  }
}

CustomFieldValueRow.propTypes = {
  customFieldKey: PropTypes.shape({
    name: PropTypes.string
  }).isRequired,
  value: PropTypes.string.isRequired,
  count: PropTypes.number.isRequired,
  updateValues: PropTypes.func.isRequired,
};

export default CustomFieldValueRow;
